
import { Address } from "../entity/address";
import { CustomerEntity } from "../entity/customer/customer.entity";



export class CustomerDetailDto {
    customer?: CustomerEntity;
    address?: Address;
    customerTypeName?: string;
    communityName?: string;
    isFavorite?: boolean;
    customerSourceName?: string;
}
